"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailedMappingInputParsingError = exports.inputDetailedMappingDataSchema = exports.detailedMappingOutputDataSchema = exports.detailedMappingSingleDisplayValueFieldSchema = exports.DateType = exports.DetailedMappingFieldTypes = void 0;
const t = __importStar(require("typegate"));
var DetailedMappingFieldTypes;
(function (DetailedMappingFieldTypes) {
    DetailedMappingFieldTypes["input"] = "input";
    DetailedMappingFieldTypes["textarea"] = "textarea";
    DetailedMappingFieldTypes["radio"] = "radio";
    DetailedMappingFieldTypes["dropdown"] = "dropdown";
    DetailedMappingFieldTypes["date"] = "date";
    DetailedMappingFieldTypes["number"] = "number";
    DetailedMappingFieldTypes["money"] = "money";
    DetailedMappingFieldTypes["agree"] = "agree";
    DetailedMappingFieldTypes["checkboxGroup"] = "checkboxGroup";
    DetailedMappingFieldTypes["phone"] = "phone";
})(DetailedMappingFieldTypes || (exports.DetailedMappingFieldTypes = DetailedMappingFieldTypes = {}));
var DateType;
(function (DateType) {
    DateType["date"] = "date";
    DateType["yearMonth"] = "yearMonth";
})(DateType || (exports.DateType = DateType = {}));
/**
 * _____________________________________________________________
 * Output types
 */
const detailedMappingBaseFieldSchema = t
    .object(t.property('id', t.string), t.property('questionText', t.string), t.property('questionSubtext', t.string))
    .setTypeName('DetailedMappingBaseField');
const detailedMappingRadioFieldSchema = t
    .intersection(detailedMappingBaseFieldSchema, t.object(t.property('type', t.literal(DetailedMappingFieldTypes.radio)), t.property('displayValue', t.string), t.property('value', t.string)))
    .setTypeName('DetailedMappingRadioField');
const detailedMappingDropdownFieldSchema = t
    .intersection(detailedMappingBaseFieldSchema, t.object(t.property('type', t.literal(DetailedMappingFieldTypes.dropdown)), t.property('displayValue', t.string), t.property('value', t.string)))
    .setTypeName('DetailedMappingDropdownField');
const detailedMappingAgreeFieldSchema = t
    .intersection(detailedMappingBaseFieldSchema, t.object(t.property('type', t.literal(DetailedMappingFieldTypes.agree)), t.property('displayValue', t.string), t.property('value', t.boolean)))
    .setTypeName('DetailedMappingAgreeField');
const detailedMappingPhoneFieldSchema = t
    .intersection(detailedMappingBaseFieldSchema, t.object(t.property('type', t.literal(DetailedMappingFieldTypes.phone)), t.property('value', t.string)))
    .setTypeName('DetailedMappingTextareaField');
const detailedMappingTextareaFieldSchema = t
    .intersection(detailedMappingBaseFieldSchema, t.object(t.property('type', t.literal(DetailedMappingFieldTypes.textarea)), t.property('value', t.string)))
    .setTypeName('DetailedMappingTextareaField');
const detailedMappingInputFieldSchema = t
    .intersection(detailedMappingBaseFieldSchema, t.object(t.property('type', t.literal(DetailedMappingFieldTypes.input)), t.property('value', t.union(t.string, t.number))))
    .setTypeName('DetailedMappingInputField');
const detailedMappingDateFieldSchema = t
    .intersection(detailedMappingBaseFieldSchema, t.object(t.property('type', t.literal(DetailedMappingFieldTypes.date)), t.property('value', t.string), t.property('dateType', t.string)))
    .setTypeName('DetailedMappingDateField');
const detailedMappingMoneyFieldSchema = t
    .intersection(detailedMappingBaseFieldSchema, t.object(t.property('type', t.literal(DetailedMappingFieldTypes.money)), t.property('value', t.number)))
    .setTypeName('DetailedMappingMoneyField');
const detailedMappingNumberFieldSchema = t
    .intersection(detailedMappingBaseFieldSchema, t.object(t.property('type', t.literal(DetailedMappingFieldTypes.number)), t.property('value', t.number)))
    .setTypeName('DetailedMappingNumberField');
const detailedMappingCheckboxGroupFieldSchema = t
    .intersection(detailedMappingBaseFieldSchema, t.object(t.property('type', t.literal(DetailedMappingFieldTypes.checkboxGroup)), t.property('value', t.array(t.string)), t.property('displayValue', t.array(t.string))))
    .setTypeName('DetailedMappingCheckboxGroupField');
exports.detailedMappingSingleDisplayValueFieldSchema = t.union(detailedMappingDropdownFieldSchema, detailedMappingRadioFieldSchema);
const detailedMappingFieldSchema = t
    .discriminatedUnion('type', detailedMappingRadioFieldSchema, detailedMappingDropdownFieldSchema, detailedMappingAgreeFieldSchema, detailedMappingPhoneFieldSchema, detailedMappingTextareaFieldSchema, detailedMappingDateFieldSchema, detailedMappingInputFieldSchema, detailedMappingMoneyFieldSchema, detailedMappingNumberFieldSchema, detailedMappingCheckboxGroupFieldSchema)
    .setTypeName('DetailedMappingField');
const detailedMappingCollectionSchema = t
    .object(t.property('type', t.literal('collection')), t.property('id', t.string), t.property('questionText', t.string), t.property('questionSubtext', t.string), t.property('children', t.array(t.lazy(() => detailedMappingCollectionItemSchema))))
    .setTypeName('DetailedMappingCollection');
const detailedMappingCollectionItemSchema = t
    .object(t.property('surrogateId', t.string), t.property('type', t.literal('collectionItem')), t.property('data', t.record(t.string, t.union(detailedMappingFieldSchema, detailedMappingCollectionSchema))))
    .setTypeName('DetailedMappingCollectionItem');
exports.detailedMappingOutputDataSchema = t
    .record(t.string, t.union(detailedMappingFieldSchema, detailedMappingCollectionSchema))
    .setTypeName('DetailedMappingOutputData');
/**
 * _____________________________________________________________
 * Input types
 */
const inputDetailedMappingBaseFieldSchema = t
    .object(t.property('id', t.string), t.optionalProperty('questionText', t.union(t.string, t.undefined)), t.optionalProperty('questionSubtext', t.union(t.string, t.undefined)))
    .setTypeName('InputDetailedMappingBaseField');
const inputDetailedMappingRadioFieldSchema = t.intersection(inputDetailedMappingBaseFieldSchema, t.pick(detailedMappingRadioFieldSchema, ['value', 'type']), t.object(t.optionalProperty('displayValue', t.union(t.string, t.undefined))));
const inputDetailedMappingDropdownFieldSchema = t.intersection(inputDetailedMappingBaseFieldSchema, t.pick(detailedMappingDropdownFieldSchema, ['value', 'type']), t.object(t.optionalProperty('displayValue', t.union(t.string, t.undefined))));
const inputDetailedMappingAgreeFieldSchema = t.intersection(t.pick(detailedMappingAgreeFieldSchema, ['value', 'type']), inputDetailedMappingBaseFieldSchema);
const inputDetailedMappingPhoneFieldSchema = t.intersection(t.pick(detailedMappingPhoneFieldSchema, ['value', 'type']), inputDetailedMappingBaseFieldSchema);
const inputDetailedMappingTextareaFieldSchema = t.intersection(t.pick(detailedMappingTextareaFieldSchema, ['value', 'type']), inputDetailedMappingBaseFieldSchema);
const inputDetailedMappingInputFieldSchema = t.intersection(t.pick(detailedMappingInputFieldSchema, ['value', 'type']), inputDetailedMappingBaseFieldSchema);
const inputDetailedMappingDateFieldSchema = t.intersection(t.pick(detailedMappingDateFieldSchema, ['value', 'type', 'dateType']), inputDetailedMappingBaseFieldSchema);
const inputDetailedMappingMoneyFieldSchema = t.intersection(t.pick(detailedMappingMoneyFieldSchema, ['value', 'type']), inputDetailedMappingBaseFieldSchema);
const inputDetailedMappingNumberFieldSchema = t.intersection(t.pick(detailedMappingNumberFieldSchema, ['value', 'type']), inputDetailedMappingBaseFieldSchema);
const inputDetailedMappingCheckboxGroupFieldSchema = t.intersection(inputDetailedMappingBaseFieldSchema, t.pick(detailedMappingCheckboxGroupFieldSchema, ['value', 'type']), t.object(t.optionalProperty('displayValue', t.union(t.array(t.string), t.undefined))));
const inputDetailedMappingFieldSchema = t
    .discriminatedUnion('type', inputDetailedMappingRadioFieldSchema, inputDetailedMappingDropdownFieldSchema, inputDetailedMappingAgreeFieldSchema, inputDetailedMappingPhoneFieldSchema, inputDetailedMappingTextareaFieldSchema, inputDetailedMappingInputFieldSchema, inputDetailedMappingDateFieldSchema, inputDetailedMappingMoneyFieldSchema, inputDetailedMappingNumberFieldSchema, inputDetailedMappingCheckboxGroupFieldSchema)
    .setTypeName('InputDetailedMappingField');
const inputDetailedMappingCollectionSchema = t
    .object(t.property('type', t.literal('collection')), t.property('id', t.string), t.property('children', t.array(t.lazy(() => inputDetailedMappingCollectionItemSchema))))
    .setTypeName('InputDetailedMappingCollection');
const inputDetailedMappingCollectionItemSchema = t
    .object(t.optionalProperty('surrogateId', t.string), t.property('type', t.literal('collectionItem')), t.property('data', t.record(t.string, t.union(inputDetailedMappingFieldSchema, inputDetailedMappingCollectionSchema))))
    .setTypeName('InputDetailedMappingCollectionItem');
exports.inputDetailedMappingDataSchema = t
    .record(t.string, t.union(inputDetailedMappingFieldSchema, inputDetailedMappingCollectionSchema))
    .setTypeName('InputDetailedMappingData');
class DetailedMappingInputParsingError extends Error {
    tag = 'DetailedMappingInputParsingError';
}
exports.DetailedMappingInputParsingError = DetailedMappingInputParsingError;
